const SetupAdministration = (() => {
  let regionsData, regionsTable, vendorList;
  let locationsData, locationsTable, regionsListData, countyServicesListData;

  function getRegionsView() {
    const frag = document.createDocumentFragment();

    regionsTable = table.build({
      tableId: 'regionsSetupTable',
      columnHeadings: ['Region', 'Vendor', 'Active?'],
      endIcon: true,
    });

    const headers = regionsTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');
    headers[1].setAttribute('data-type', 'string');
    headers[2].setAttribute('data-type', 'string');

    const addRegionsBtnDiv = document.createElement('div');
    const addRegionsBtn = new Button({
      text: 'ADD NEW REGION',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(regionsTable);
    if ($.session.SetupInsert) {
      addRegionsBtn.button.style.float = 'right';
      addRegionsBtn.renderTo(addRegionsBtnDiv);
      frag.append(addRegionsBtnDiv);
    }

    const tableRegionsData = regionsData
      .map(cd => {
        return {
          values: [cd.Regions, cd.Vendor, cd.IsActive == 'Y' ? 'Yes' : 'No'],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showRegionsPopup(cd);
          },
          endIconCallback: () => handleRegionsDelete(cd),
        };
      });

    table.populate(regionsTable, tableRegionsData);
    table.sortTableByHeader(regionsTable);

    addRegionsBtn.onClick(e => {
      showRegionsPopup();
    });
    return frag;
  }

  function getParentRegions() {
    let data = [];
    for (const v of vendorList) {
      data.push({
        value: v.value,
        text: v.text,
      });
    }
    return data;
  }

  function showRegionsPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'regionPopup',
      hideX: true,
    });

    const regionsForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Region',
          id: 'wRegions',
          required: true,
          maxlength: 100,
        },
        {
          type: 'select',
          label: 'Vendor',
          id: 'wVendor',
          data: getParentRegions(),
          includeBlankOption: true,
          required: true,
        },
        {
          type: 'select',
          label: 'Active?',
          id: 'wActive',
          data: [
            { value: 'Y', text: 'Yes' },
            { value: 'N', text: 'No' },
          ],
        },
        {
          type: 'text',
          label: 'Short Description',
          id: 'wShortDescription',
          maxlength: 10,
        },
        {
          type: 'text',
          label: 'GL Code',
          id: 'wGLCode',
          maxlength: 50,
        },
        {
          type: 'text',
          label: 'Payroll Dept',
          id: 'wPayrollDept',
          maxlength: 50,
        }
      ],
    });


    const inputs = ['wRegions', 'wShortDescription', 'wGLCode', 'wPayrollDept'];
    inputs.forEach(input => {
      regionsForm.inputs[input].onKeyup(event => {
        regionsForm.inputs['wRegions'].setValidtyError('');
        regionsForm.inputs['wRegions'].clearErrorOrWarning();
        checkForRequiredFields(regionsForm);
        if (regionsForm.inputs['wRegions'].input.value != '' && regionsForm.inputs['wRegions'].input.value.trim() != '' && regionsForm.inputs['wVendor'].select.value !== '') {
          regionsForm.buttons['submit'].toggleDisabled(false);
        } else {
          regionsForm.buttons['submit'].toggleDisabled(true);
        }
      });
    });

    const selectes = ['wActive', 'wVendor'];
    selectes.forEach(select => {
      regionsForm.inputs[select].onChange(event => {
        regionsForm.inputs['wRegions'].setValidtyError('');
        regionsForm.inputs['wRegions'].clearErrorOrWarning();
        checkForRequiredFields(regionsForm);
        if (regionsForm.inputs['wRegions'].input.value != '' && regionsForm.inputs['wRegions'].input.value.trim() != '' && regionsForm.inputs['wVendor'].select.value !== '') {
          regionsForm.buttons['submit'].toggleDisabled(false);
        } else {
          regionsForm.buttons['submit'].toggleDisabled(true);
        }
      });
    });

    regionsForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateRegionsData', {
          token: $.session.Token,
          regionsId: rowData ? rowData.regionsId : 0,
          regions: formdata.wRegions,
          vendor: formdata.wVendor,
          isActive: formdata.wActive,
          shortDescription: formdata.wShortDescription,
          gLCode: formdata.wGLCode,
          payrollDept: formdata.wPayrollDept,
          userId: $.session.UserId,
        })
      ).insertUpdateRegionsDataResult;
      const newID = resp.regionsId;
      if (newID == '-1') {
        showAlreadyExistsWarning(regionsForm, 'This region already exists.')
      } else {
        regionsForm.clear();
        POPUP.hide(popup);
        await init();
        updateRegionsTable();
      }
    });

    regionsForm.onCancel(event => {
      regionsForm.clear();
      regionsForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    regionsForm.renderTo(popup);
    POPUP.show(popup);
    regionsForm.populate({
      wRegions: rowData ? rowData.Regions : '',
      wVendor: rowData ? rowData.VendorId : '',
      wActive: rowData ? rowData.IsActive : 'Y',
      wShortDescription: rowData ? rowData.ShortDescription : '',
      wGLCode: rowData ? rowData.GLCode : '',
      wPayrollDept: rowData ? rowData.PayrollDept : '',
    });

    regionsForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      regionsForm.disableFormInputs();
    }
  }

  async function handleRegionsDelete(row) {
    const rowData = regionsData.find(a => a.regionsId == row.regionsId);
    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This region cannot be deleted, because it is used somewhere else in Advisor Anywhere.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this region?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteRegionsSetup', {
            token: $.session.Token,
            regionsId: row.regionsId,
          })
          await init();
          updateRegionsTable();
        }
      });
    }
  }
  function updateRegionsTable() {
    const tableRegionsData = regionsData
      .map(cd => {
        return {
          values: [cd.Regions, cd.Vendor, cd.IsActive == 'Y' ? 'Yes' : 'No'],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showRegionsPopup(cd);
          },
          endIconCallback: () => handleRegionsDelete(cd),
        };
      });

    table.populate(regionsTable, tableRegionsData);
  }



  function getLocationsView() {
    const frag = document.createDocumentFragment();

    locationsTable = table.build({
      tableId: 'locationsTable',
      columnHeadings: ['Description', 'Short Description', 'Region', 'Active?'],
      endIcon: true,
    });

    const headers = locationsTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');
    headers[1].setAttribute('data-type', 'string');
    headers[2].setAttribute('data-type', 'string');
    headers[3].setAttribute('data-type', 'string');

    const addLocationsBtnDiv = document.createElement('div');
    const addLocationsBtn = new Button({
      text: 'ADD NEW LOCATION',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(locationsTable);
    if ($.session.SetupInsert) {
      addLocationsBtn.button.style.float = 'right';
      addLocationsBtn.renderTo(addLocationsBtnDiv);
      frag.append(addLocationsBtnDiv);
    }

    const tableLocationsData = locationsData
      .map(cd => {
        return {
          values: [cd.locationDescription, cd.locationShortDescription, cd.regionName, cd.active == 'Y' ? 'Yes' : 'No'],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showLocationsPopup(cd);
          },
          endIconCallback: () => handleLocationsDelete(cd),
        };
      });

    table.populate(locationsTable, tableLocationsData);
    table.sortTableByHeader(locationsTable);

    addLocationsBtn.onClick(e => {
      showLocationsPopup();
    });
    return frag;
  }

  function getRegionsDropdownData() {
    let data = [];
    for (const v of regionsListData) {
      data.push({
        value: v.value,
        text: v.text,
      });
    }
    return data;
  }

  function getCountyServicesDropdownData() {
    let data = [];
    for (const v of countyServicesListData) {
      data.push({
        value: v.value,
        text: v.text,
      });
    }
    return data;
  }

  function showLocationsPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'locationPopup',
      hideX: true,
    });

    const locationsForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Location Description',
          id: 'wLocationDescription',
          required: true,
          maxlength: 100,
        },
        {
          type: 'text',
          label: 'Location Short Description',
          id: 'wLocationShortDescription',
          required: true,
          maxlength: 10,
        },
        {
          type: 'select',
          label: 'Region',
          id: 'wRegion',
          data: getRegionsDropdownData(),
          required: true,
        },
        {
          type: 'select',
          label: 'County of Service',
          id: 'wCountyOfService',
          data: getCountyServicesDropdownData(),
          required: true,
        },
        {
          type: 'text',
          label: 'Address1',
          id: 'wAddress1',
          maxlength: 50,
        },
        {
          type: 'text',
          label: 'Address2',
          id: 'wAddress2',
          maxlength: 50,
        },
        {
          type: 'text',
          label: 'City',
          id: 'wCity',
          maxlength: 30,
        },
        {
          type: 'text',
          label: 'State',
          id: 'wState',
          maxlength: 2,
        },
        {
          type: 'text',
          label: 'Zip Code',
          id: 'wZipCode',
          maxlength: 10,
        },
        {
          type: 'text',
          label: 'Phone1',
          id: 'wPhone1',
          maxlength: 19,
        },
        {
          type: 'select',
          label: 'Active?',
          id: 'wActive',
          data: [
            { value: 'Y', text: 'Yes' },
            { value: 'N', text: 'No' },
          ],
        },
        {
          type: 'select',
          label: 'Residence?',
          id: 'wResidence',
          includeBlankOption: false,
          data: [
            { value: 'Y', text: 'Yes' },
            { value: 'N', text: 'No' },
          ],
        },
        {
          type: 'heading',
          label: 'Accounting',
          id: 'hAccounting',
        },
        {
          type: 'text',
          label: 'GL Code',
          id: 'wGLCode',
          maxlength: 50,
        },
        {
          type: 'text',
          label: 'Payroll Department',
          id: 'wPayrollDepartment',
          maxlength: 50,
        },
        {
          type: 'select',
          label: 'Single-Entry Transportation Reimbursable',
          id: 'wSingleEntryTransReimb',
          includeBlankOption: false,
          data: [
            { value: 'Y', text: 'Yes' },
            { value: 'N', text: 'No' },
          ],
        },
        {
          type: 'heading',
          label: 'Defaults',
          id: 'hDefaults',
        },
        {
          type: 'select',
          label: 'Time Zone',
          id: 'wTimeZone',
          data: [
            { value: 'CT', text: 'Central Time Zone' },
            { value: 'ET', text: 'Eastern Time Zone' },
            { value: 'MT', text: 'Mountain Time Zone' },
            { value: 'PT', text: 'Pacific Time Zone' },
          ],
        },
        {
          type: 'select',
          label: 'Day Service Type',
          id: 'wDayServiceType',
          data: [
            { value: 'A', text: 'Adult Day Support' },
            { value: 'G', text: 'Group Employment' },
            { value: 'S', text: 'Community Integration Adult Day Support' },
            { value: 'X', text: 'Community Integration Vocational Habilitation' },
            { value: 'D', text: 'Virtual Adult Day Support' },
            { value: 'Y', text: 'Virtual Vocational Habilitation' },
            { value: 'V', text: 'Vocational Habilitation' },
          ],
        },
        {
          type: 'heading',
          label: 'MSS',
          id: 'hMSS',
        },
        {
          type: 'text',
          label: 'Setting Name',
          id: 'wSettingName',
          maxlength: 50,
        },
        {
          type: 'number',
          label: 'Site #',
          id: 'wSite',
        },
        {
          type: 'date',
          label: 'Transition Date',
          id: 'wTransitionDate',
        },
        {
          type: 'heading',
          label: 'Miscellaneous',
          id: 'hMiscellaneous',
        },
        {
          type: 'text',
          label: 'County Location Code',
          id: 'wCountyLocationCode',
          maxlength: 15,
        },
        {
          type: 'text',
          label: 'NPI',
          id: 'wNPI',
          maxlength: 30,
        },
        {
          type: 'text',
          label: 'Medicaid Provider Number',
          id: 'wMedicaidProviderNumber',
          maxlength: 30,
        },
        {
          type: 'text',
          label: 'Facility Number',
          id: 'wFacilityNumber',
          maxlength: 20,
        },
        {
          type: 'textarea',
          label: 'Notes',
          id: 'wNotes',
          maxlength: 200,
        }
      ],
    });

    locationsForm.inputs['wZipCode'].onPaste(event => {
      event.preventDefault();
    });

    locationsForm.inputs['wState'].onPaste(event => {
      event.preventDefault();
    });

    const inputs = ['wLocationDescription', 'wLocationShortDescription', 'wAddress1', 'wAddress2', 'wCity', 'wState', 'wZipCode', 'wPhone1', 'wGLCode',
      'wPayrollDepartment', 'wSettingName', 'wSite', 'wTransitionDate', 'wCountyLocationCode', 'wNPI', 'wMedicaidProviderNumber', 'wFacilityNumber',
      'wNotes'];
    inputs.forEach(input => {
      locationsForm.inputs[input].onKeyup(event => {
        locationsForm.inputs['wLocationDescription'].setValidtyError('');
        locationsForm.inputs['wLocationDescription'].clearErrorOrWarning();
        checkForRequiredFields(locationsForm);

        if (
          (locationsForm.inputs['wLocationDescription'].input.value != '' && locationsForm.inputs['wLocationDescription'].input.value.trim() != '') &&
          (locationsForm.inputs['wLocationShortDescription'].input.value != '' && locationsForm.inputs['wLocationShortDescription'].input.value.trim() != '') &&
          (locationsForm.inputs['wRegion'].select.value != '') &&
          (locationsForm.inputs['wCountyOfService'].select.value != '') && ((locationsForm.inputs['wResidence'].select.value == 'N' && locationsForm.inputs['wDayServiceType'].select.value != '') ||
            (locationsForm.inputs['wResidence'].select.value == 'Y'))
        ) {
          locationsForm.buttons['submit'].toggleDisabled(false);
        } else {
          locationsForm.buttons['submit'].toggleDisabled(true);
        }
        if (event.target.id == 'wZipCode') {
          let zipcode = locationsForm.inputs['wZipCode'].input.value;
          var reg = new RegExp('^[0-9 -]+$');
          if (zipcode) {
            if (!reg.test(zipcode)) {
              locationsForm.inputs['wZipCode'].input.value = zipcode.substring(0, zipcode.length - 1);
              return;
            }
            zipcode = zipcode.split('-').join('');
            let finalVal = zipcode.match(/.{1,5}/g).join('-');
            locationsForm.inputs['wZipCode'].input.value = finalVal;
          }
        }
        if (event.target.id == 'wState') {
          let state = locationsForm.inputs['wState'].input.value;
          var reg = new RegExp('^[a-zA-Z]+$');
          if (state) {
            if (!reg.test(state)) {
              locationsForm.inputs['wState'].input.value = state.substring(0, state.length - 1);
              return;
            }
          }
        }
        if (event.target.id == 'wPhone1') {
          let phoneNo = locationsForm.inputs['wPhone1'].input.value;
          phoneNo = phoneNo ? phoneFormat(phoneNo) : '';
          locationsForm.inputs['wPhone1'].input.value = phoneNo;
        }
      });
    });

    const selectes = ['wRegion', 'wCountyOfService', 'wActive', 'wResidence', 'wTimeZone', 'wDayServiceType', 'wSingleEntryTransReimb'];
    selectes.forEach(select => {
      locationsForm.inputs[select].onChange(event => {
        locationsForm.inputs['wLocationDescription'].setValidtyError('');
        locationsForm.inputs['wLocationDescription'].clearErrorOrWarning();

        if (locationsForm.inputs['wResidence'].select.value == 'N') {
          locationsForm.inputs['wDayServiceType'].select.setAttribute('required', true);
        } else {
          locationsForm.inputs['wDayServiceType'].select.removeAttribute('required');
        }
        checkForRequiredFields(locationsForm);

        if (
          (locationsForm.inputs['wLocationDescription'].input.value != '' && locationsForm.inputs['wLocationDescription'].input.value.trim() != '') &&
          (locationsForm.inputs['wLocationShortDescription'].input.value != '' && locationsForm.inputs['wLocationShortDescription'].input.value.trim() != '') &&
          (locationsForm.inputs['wRegion'].select.value != '') &&
          (locationsForm.inputs['wCountyOfService'].select.value != '') && ((locationsForm.inputs['wResidence'].select.value == 'N' && locationsForm.inputs['wDayServiceType'].select.value != '') ||
            (locationsForm.inputs['wResidence'].select.value == 'Y'))
        ) {
          locationsForm.buttons['submit'].toggleDisabled(false);
        } else {
          locationsForm.buttons['submit'].toggleDisabled(true);
        }
      });
    });

    locationsForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateLocationsData', {
          token: $.session.Token,
          locationsId: rowData ? rowData.locationsId : 0,
          locationDescription: formdata.wLocationDescription,
          locationShortDescription: formdata.wLocationShortDescription,
          address1: formdata.wAddress1,
          address2: formdata.wAddress2,
          city: formdata.wCity,
          state: formdata.wState,
          zipCode: formdata.wZipCode,
          phone1: formdata.wPhone1 ? formdata.wPhone1.replace(/\D/g, '') : '',
          gLCode: formdata.wGLCode,
          payrollDepartment: formdata.wPayrollDepartment,
          region: formdata.wRegion,
          countyOfService: formdata.wCountyOfService,
          active: formdata.wActive,
          residence: formdata.wResidence,
          timeZone: formdata.wTimeZone,
          dayServiceType: formdata.wDayServiceType,
          settingName: formdata.wSettingName,
          site: formdata.wSite,
          transitionDate: formdata.wTransitionDate,
          countyLocationCode: formdata.wCountyLocationCode,
          NPI: formdata.wNPI,
          medicaidProviderNumber: formdata.wMedicaidProviderNumber,
          facilityNumber: formdata.wFacilityNumber,
          notes: formdata.wNotes,
          singleEntryTransReimb: formdata.wSingleEntryTransReimb,
          userId: $.session.UserId,
        })
      ).insertUpdateLocationsDataResult;
      const newID = resp.locationsId;

      if (newID == '-1') {
        showAlreadyExistsWarning(locationsForm, 'A location with this Short Description already exists.')
      } else {
        locationsForm.clear();
        POPUP.hide(popup);
        await locationInit();
        updateLocationsTable();
      }
    });

    locationsForm.onCancel(event => {
      locationsForm.clear();
      locationsForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    locationsForm.renderTo(popup);

    POPUP.show(popup);

    locationsForm.populate({
      wLocationDescription: rowData ? rowData.locationDescription : '',
      wLocationShortDescription: rowData ? rowData.locationShortDescription : '',
      wAddress1: rowData ? rowData.address1 : '',
      wAddress2: rowData ? rowData.address2 : '',
      wCity: rowData ? rowData.city : '',
      wState: rowData ? rowData.state : '',
      wZipCode: rowData ? rowData.zipCode : '',
      wPhone1: rowData ? phoneFormat(rowData.phone1) : '',
      wGLCode: rowData ? rowData.gLCode : '',
      wPayrollDepartment: rowData ? rowData.payrollDepartment : '',
      wRegion: rowData ? rowData.region : '',
      wCountyOfService: rowData ? rowData.countyOfService : '',
      wActive: rowData ? rowData.active : 'Y',
      wResidence: rowData ? rowData.residence : 'Y',
      wTimeZone: rowData ? rowData.timeZone : 'ET',
      wDayServiceType: rowData ? rowData.dayServiceType : '',
      wSettingName: rowData ? rowData.settingName : '',
      wSite: rowData ? rowData.site : '',
      wTransitionDate: rowData ? rowData.transitionDate : '',
      wCountyLocationCode: rowData ? rowData.countyLocationCode : '',
      wNPI: rowData ? rowData.NPI : '',
      wMedicaidProviderNumber: rowData ? rowData.medicaidProviderNumber : '',
      wFacilityNumber: rowData ? rowData.facilityNumber : '',
      wNotes: rowData ? rowData.notes : '',
      wSingleEntryTransReimb: rowData ? rowData.singleEntryTransReimb : 'Y',
    });

    locationsForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      locationsForm.disableFormInputs();
    }
  }

  async function handleLocationsDelete(row) {
    const rowData = locationsData.find(a => a.locationsId == row.locationsId);
    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This location cannot be deleted, because it is used somewhere else.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this location?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteLocationsSetup', {
            token: $.session.Token,
            locationsId: row.locationsId,
          })
          await locationInit();
          updateLocationsTable();
        }
      });
    }
  }

  function updateLocationsTable() {
    const tableLocationsData = locationsData
      .map(cd => {
        return {
          values: [cd.locationDescription, cd.locationShortDescription, cd.regionName, cd.active == 'Y' ? 'Yes' : 'No'],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showLocationsPopup(cd);
          },
          endIconCallback: () => handleLocationsDelete(cd),
        };
      });

    table.populate(locationsTable, tableLocationsData);
  }

  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }

  function showAlreadyExistsWarning(form, msg) {
    const warningPopup = POPUP.build({});
    form.disableFormInputs(true);
    form.buttons['submit'].toggleDisabled(true);
    form.buttons['cancel'].toggleDisabled(true);

    warningPopup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok',
      type: 'contained',
      style: 'secondary',
      callback: () => {
        POPUP.hide(warningPopup);
        const overlay = document.querySelector('.overlay');
        overlay.classList.add('visible');
        form.buttons['submit'].toggleDisabled(false);
        form.buttons['cancel'].toggleDisabled(false);
        form.disableFormInputs(false);
      },
    });
    btnWrap.appendChild(okBtn);
    warningPopup.appendChild(message);
    warningPopup.appendChild(btnWrap);
    POPUP.show(warningPopup);
    const closeBtn = warningPopup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }

  function checkForRequiredFields(formInstance) {
    const invalidElements = formInstance.form.querySelectorAll(`
      input:invalid,
      select:invalid,
      textarea:invalid
    `);

    const isFormValid = Array.from(invalidElements).every(field => field.value && field.value.trim() !== '');

    if (!isFormValid) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  function phoneFormat(phoneNo) {
    phoneNo = phoneNo.replace(/\D/g, '');
    if (phoneNo.length > 14) {
      phoneNo = phoneNo.substring(0, 14);
    }
    // Pattern groups: 3-3-4-(4)
    let match = phoneNo.match(/^(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
    if (match) {
      let finalVal = match[1];
      if (match[2]) finalVal += '-' + match[2];
      if (match[3]) finalVal += '-' + match[3];
      if (match[4]) finalVal += ' (' + match[4] + ')';
      phoneNo = finalVal;
    }
    return phoneNo;
  }

  async function getView(viewName) {
    const viewFragment = document.createDocumentFragment();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = viewName;

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Regions') {
      await init();
      viewMarkup = getRegionsView();
    }

    if (viewName === 'Locations') {
      await locationInit();
      viewMarkup = getLocationsView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }
  async function locationInit() {
    const dataLocations = await _UTIL.fetchData('getLocationSetupData', {
      token: $.session.Token,
      userId: $.session.UserId,
    });
    locationsData = dataLocations.getLocationSetupDataResult;

    const regionListResult = await _UTIL.fetchData('getActiveRegionList', { token: $.session.Token });
    regionsListData = regionListResult.getActiveRegionListResult;

    const countyServicesListResult = await _UTIL.fetchData('getCountyServicesList', { token: $.session.Token });
    countyServicesListData = countyServicesListResult.getCountyServicesListResult;
  }

  async function init() {
    const dataRegions = await _UTIL.fetchData('getRegionsSetupData', {
      token: $.session.Token,
      userId: $.session.UserId,
    });
    regionsData = dataRegions.getRegionsSetupDataResult;
    const vendorListResult = await _UTIL.fetchData('getActiveVendorsList', { token: $.session.Token });
    vendorList = vendorListResult.getActiveVendorsListResult;
  }

  return {
    init,
    getView,
  };
})();
